import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Autocomplete, Box, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useFormikContext } from "formik";
import { useMemo } from "react";
import useAPI from "../../../../../api/hooks/useAPI";
import { serviceNowKeys } from "../../../../../api/queryKeys";
import AnchorPopper from "../../../../../components/forms/AnchorPopper";
import {
  StyledTextField,
  getTextFieldInputProps,
  textFieldLabelProps,
} from "../../../../../components/forms/styles/formFieldStyles";

const ServiceNowUrgency = () => {
  const { values, errors, touched, handleBlur, setFieldValue } =
    useFormikContext();
  const { getServiceNowUrgencies } = useAPI();

  const hasError = !!touched.urgency && !!errors.urgency;
  const errorMessage =
    hasError && typeof errors.urgency === "string" ? errors.urgency : "";

  const urgencyLabel = useMemo(() => {
    const hasValue = values.urgency;
    const labelText = hasValue ? "Urgency" : "Select urgency";

    return <Typography variant="caption">{labelText}</Typography>;
  }, [values.urgency]);

  const { data: urgencyOptions = [], isLoading } = useQuery({
    queryKey: serviceNowKeys.urgencies,
    queryFn: async () => {
      const response = await getServiceNowUrgencies();
      return response.data || [];
    },
  });

  return (
    <Autocomplete
      options={urgencyOptions}
      value={
        urgencyOptions.find((option) => option.value === values.urgency) || null
      }
      onChange={(_, newValue) =>
        setFieldValue("urgency", newValue?.value || "")
      }
      getOptionLabel={(option) => option?.label || ""}
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      popupIcon={<ExpandMoreIcon />}
      PopperComponent={AnchorPopper}
      loading={isLoading}
      renderOption={(props, option) => (
        <Box component="li" {...props}>
          <Typography variant="caption">{option.label}</Typography>
        </Box>
      )}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          margin="dense"
          label={urgencyLabel}
          fullWidth
          required
          error={hasError}
          helperText={errorMessage}
          onBlur={handleBlur}
          InputProps={getTextFieldInputProps(params.InputProps)}
          InputLabelProps={textFieldLabelProps(params.InputLabelProps)}
        />
      )}
    />
  );
};

export default ServiceNowUrgency;
